module.exports = __webpack_public_path__ + "media/images/lp/industries/issue_logistics_sp-473b473a487e746ec331a34c2ce1184d.svg";